import classNames from 'classnames/bind';

export function getClassNames(styles = {}, classes = '', conditionals = {}) {
    return classNames.bind(styles)(conditionals, classes);
}